/**
 * Image modal wiring.
 *
 * Listens for clicks on any <a href="#image-modal-<slug>"> on the page.
 * Opens the matching <dialog data-image-modal="<slug>"> via showModal().
 * Closes on: close button, backdrop click, Escape (native <dialog> behavior).
 */
(function () {
  if (window.__imageModalInit) return;
  window.__imageModalInit = true;

  var TRIGGER_PREFIX = '#image-modal-';

  function openModal(slug) {
    var dialog = document.querySelector(
      '[data-image-modal="' + CSS.escape(slug) + '"]'
    );
    if (!dialog) return false;

    if (typeof dialog.showModal === 'function') {
      try {
        dialog.showModal();
      } catch (e) {
        // Already open, or not in a state showModal() accepts.
        return false;
      }
    } else {
      // Fallback for browsers without <dialog> support.
      dialog.setAttribute('open', '');
    }
    document.body.classList.add('image-modal-scroll-locked');
    return true;
  }

  function closeModal(dialog) {
    if (!dialog) return;
    if (typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
    dialog.removeAttribute('data-zoomed');
    document.body.classList.remove('image-modal-scroll-locked');
  }

  // Global click delegation: triggers.
  document.addEventListener('click', function (e) {
    var anchor = e.target.closest('a[href^="' + TRIGGER_PREFIX + '"]');
    if (!anchor) return;

    var href = anchor.getAttribute('href') || '';
    var slug = href.slice(TRIGGER_PREFIX.length);
    if (!slug) return;

    if (openModal(slug)) {
      e.preventDefault();
    }
  });

  // Close via close button or backdrop.
  document.addEventListener('click', function (e) {
    var closer = e.target.closest('[data-image-modal-close]');
    if (!closer) return;
    var dialog = closer.closest('[data-image-modal]');
    closeModal(dialog);
  });

  // Toggle zoom on image click.
  document.addEventListener('click', function (e) {
    var img = e.target.closest('.image-modal-image');
    if (!img) return;
    var dialog = img.closest('[data-image-modal]');
    if (!dialog) return;
    var zoomed = dialog.getAttribute('data-zoomed') === 'true';
    if (zoomed) {
      dialog.removeAttribute('data-zoomed');
    } else {
      dialog.setAttribute('data-zoomed', 'true');
      var panel = dialog.querySelector('.image-modal-panel');
      if (panel) panel.scrollTop = 0;
    }
  });

  // Keep body scroll-lock state in sync when dialog closes via Escape or .close().
  document.addEventListener('close', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-image-modal]')) {
      document.body.classList.remove('image-modal-scroll-locked');
    }
  }, true);
})();
